import http from '@/communication/AuthConnection'

export default ({ clientName }) => {
  return http.get('/v1/search-client-by-name', { params: { clientName } })
    .then(pData => pData.data)
}



// WEBPACK FOOTER //
// ./src/brain/record/client/SearchClientByName.js